import React, { useState, useEffect } from 'react'
import { useTransition, animated } from '@react-spring/web'

const STATUS_ROTATE_MS = 4000

export default function SlideStatus({ phrases }) {
  const items = phrases.filter(Boolean)
  const [index, setIndex] = useState(0)

  useEffect(() => {
    setIndex(0)
  }, [items.length])

  useEffect(() => {
    if (items.length < 2) return undefined
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % items.length)
    }, STATUS_ROTATE_MS)
    return () => clearInterval(id)
  }, [items.length])

  const transitions = useTransition(index, {
    keys: index,
    from: { opacity: 0, transform: 'translateY(6px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-6px)' },
    exitBeforeEnter: true,
  })

  if (!items.length) return null

  return (
    <div className="slide-status">
      {transitions((styles, i) => (
        <animated.div className="slide-status-phrase" style={styles}>
          {items[i]}
        </animated.div>
      ))}
    </div>
  )
}
